/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle Preview (Magnified)" |
*
* @param {Video_Export_Magnified_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_title = /** @type {((inputs?: Video_Export_Magnified_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation des sous-titres (agrandie)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelvorschau (vergrößert)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima dei sottotitoli (ingrandita)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр субтитров (увеличенный)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa de subtítulos (ampliada)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕预览（放大）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕プレビュー（拡大）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक पूर्वावलोकन (बड़ा करके)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização da legenda (ampliada)")
	return /** @type {LocalizedString} */ ("Subtitle Preview (Magnified)")
});